import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiDownload, FiImage } = FiIcons;

function ProofViewer({ isOpen, onClose, imageUrl, fileName, loading }) {
  if (!isOpen) return null;

  const handleDownload = async () => {
    if (!imageUrl) return;
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = fileName || 'payment-proof.jpg';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(blobUrl);
    } catch {
      window.open(imageUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="proof-viewer-overlay" onClick={onClose}>
      <div className="proof-viewer-modal" onClick={(e) => e.stopPropagation()}>
        <div className="proof-viewer-header">
          <span className="proof-viewer-title">
            {fileName || 'Payment Proof'}
          </span>
          <div className="proof-viewer-actions">
            <button
              className="proof-download-btn"
              onClick={handleDownload}
              disabled={!imageUrl || loading}
              title="Download proof"
            >
              <SafeIcon icon={FiDownload} />
              Download
            </button>
            <button
              className="proof-close-btn"
              onClick={onClose}
              title="Close"
            >
              <SafeIcon icon={FiX} />
            </button>
          </div>
        </div>
        <div className="proof-viewer-body">
          {loading && (
            <div className="proof-viewer-loading">Loading proof…</div>
          )}
          {!loading && imageUrl && (
            <img src={imageUrl} alt="Payment proof" />
          )}
          {!loading && !imageUrl && (
            <div className="proof-viewer-loading">
              <SafeIcon icon={FiImage} className="text-3xl" />
              <span>Proof could not be loaded.</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProofViewer;